import { useEffect, useState } from "react";
import { ServiceData } from "../../../Services/Service";
import AlerteLivraison from "../../../Services/Alert";
import useAutoAlerteSonore from "../../../Services/Alert";
interface Data{
    total_users:number;
    total_bordereaux:number;
    bordereaux_verifies:number;
    bordereaux_non_verifies:number;
    bordereaux_livres:number;
    bordereaux_non_livres:number;
}

const Dashboard = () => {
  const [data, setData] = useState<Data | null>(null);
    useEffect(()=>{
        const fetchData=async()=>{
            try{
                const response=await ServiceData("/api/admin/dashoard","GET");
                setData(response);
            }catch(error){
                console.log("Erreur lors de la chargement des données",error);
            }
        }
        fetchData();
    },[])

    if(!data){
        return <div className="text-center">Chargement des données ... </div>
    }
   return(
       <div className="container my-4">
      <h1 className="text-center mb-4">Tableau de Bord Admin</h1>

      <div className="row g-4">
        <div className="col-sm-6 col-lg-3">
          <div className="card shadow-sm border-primary h-100">
            <div className="card-body text-center">
              <h5 className="card-title text-primary">Total Utilisateurs</h5>
              <h2 className="card-subtitle fw-bold">{data.total_users}</h2>
            </div>
          </div>
        </div>

        <div className="col-sm-6 col-lg-3">
          <div className="card shadow-sm border-success h-100">
            <div className="card-body text-center">
              <h5 className="card-title text-success">Total Bordereaux</h5>
              <h2 className="card-subtitle fw-bold">{data.total_bordereaux}</h2>
            </div>
          </div>
        </div>

        <div className="col-sm-6 col-lg-3">
          <div className="card shadow-sm border-info h-100">
            <div className="card-body text-center">
              <h5 className="card-title text-info">Vérifiés</h5>
              <h2 className="card-subtitle fw-bold">{data.bordereaux_verifies}</h2>
            </div>
          </div>
        </div>

        <div className="col-sm-6 col-lg-3">
          <div className="card shadow-sm border-danger h-100">
            <div className="card-body text-center">
              <h5 className="card-title text-danger">Non Vérifiés</h5>
              <h2 className="card-subtitle fw-bold">{data.bordereaux_non_verifies}</h2>
            </div>
          </div>
        </div>
        <div className="col-sm-6 col-lg-3">
          <div className="card shadow-sm border-info h-100">
            <div className="card-body text-center">
              <h5 className="card-title text-info">Livrés</h5>
              <h2 className="card-subtitle fw-bold">{data.bordereaux_livres}</h2>
            </div>
          </div>
        </div>

        <div className="col-sm-6 col-lg-3">
          <div className="card shadow-sm border-danger h-100">
            <div className="card-body text-center">
              <h5 className="card-title text-danger">Non livrés</h5>
              <h2 className="card-subtitle fw-bold">{data.bordereaux_non_livres}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    )
}
export default Dashboard;